import { uuid } from "../uuid";

export const mixerId = uuid;
export const nullableMixerId = {
  ...mixerId,
  type: ["null", "string"]
};
